const leafletDetails = {
  state: {
    redirectsDescription: ''
  },

  mutations: {
    UPDATE_REDIRECTS_DESCRIPTION: (state, newDesc) => {
      state.redirectsDescription = newDesc
    }
  },

  actions: {
    setRedirectsDescription({ commit }, newDesc) {
      commit('UPDATE_REDIRECTS_DESCRIPTION', newDesc)
    }
  }
}

export default leafletDetails
